import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState } from "react";
import CalculatorImg from "../assets/calc.png";
import CalcWithBgImg from "../assets/calcwithbg.png";
import { ReactComponent as BridgeupDilution } from "../assets/bridgeup-dilution.svg";
import { ReactComponent as VSImg } from "../assets/vs.svg";
import { ReactComponent as VSImgHr } from "../assets/vsHr.svg";
import { BarChart } from "../charts/BarChart";
import { PieChart } from "../charts/PieChart";
import { isValidEmail, signup, pushData } from "../common";
import { ARRTable, NoOfCust, Runway, Type } from "../constants";
import * as React from "react";
import axios from "axios";

function Calculator() {
  const [arr, setArr] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailHelper, setEmailHelper] = useState("");
  const [type, setType] = useState("");
  const [runway, setRunway] = useState("");
  const [customers, setCustomers] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [focusedARR, setFocusedARR] = useState(false);
  const [inputBlur, setInputBlur] = useState(false);

  const mobile = !useMediaQuery("(min-width:768px)");

  const largeScreen = !useMediaQuery("(min-width:900px)");

  const [result, setResult] = useState({
    bitPrice: null,
    InterestRate: null,
    advance_amount: null,
    platform_fees: null,
    net_receivable: null,
    company_valuation: null,
    dilution: null,
    BridgeUp: null,
    equity: null,
    venture: null,
  });

  const executeScroll = () => {
    window.scrollTo(0, 900);
  };

  const validateEmail = (e) => {
    if (
      email.toLowerCase().indexOf("gmail") >= 0 ||
      email.toLowerCase().indexOf("microsoft") >= 0 ||
      email.toLowerCase().indexOf("icloud") >= 0 ||
      email.toLowerCase().indexOf("live") >= 0 ||
      email.toLowerCase().indexOf("outlook") >= 0 ||
      email.toLowerCase().indexOf("yahoo") >= 0
    ) {
      return setEmailHelper("Use your business email ID");
    } else {
      isValidEmail(e.target.value)
        ? setEmailHelper("")
        : setEmailHelper("Email is not valid!");
    }
  };
  //*----------------------------------------------------------------------------------------
  const handleArr = (e) => {
    setFormSubmitted(false);
    if (!e.target.value.length) setArr("");
    const numb = e.target.value.replaceAll(",", "");
    setArr(Number(numb) ? Number(numb) : "");
  };
  const handleEmail = (e) => {
    setFormSubmitted(false);
    setEmail(e.target.value);
  };
  const handlePhone = (e) => {
    setFormSubmitted(false);
    setPhoneNumber(e.target.value);
  };
  const handleType = (e) => {
    setFormSubmitted(false);
    setType(e.target.value);
  };
  const handleRunway = (e) => {
    setFormSubmitted(false);
    setRunway(e.target.value);
  };
  const handleCustomers = (e) => {
    setFormSubmitted(false);
    setCustomers(e.target.value);
  };
  //*----------------------------------------------------------------------------------------

  const calculate = async () => {
    setFormSubmitted(true);
    if (!arr || !isValidEmail(email) || !type || !runway || !customers) return;

    const percent = ARRTable.filter((item) => {
      return type === "SaaS"
        ? item.type === type &&
            item.runway === runway &&
            item.no_of_customers === customers
        : item.type === type && item.runway === runway;
    });

    if (mobile) executeScroll();

    const response = await axios.post(
      `${process.env.REACT_APP_ACTION_SERVER_BASE_URL}/calculator`,
      {
        email,
        phone: phoneNumber,
        arr: arr / 10000000,
        runway,
        type,
        customers,
      }
    );
    console.log("response", response);
    return response;
  };

  return (
    <>
      <div id="hubspotform"></div>
      <Grid
        className="calculator-wrapper"
        container
        borderRadius={"8px"}
        spacing={0}
      >
        <Grid
          className="calculater-fields-wrapper"
          item
          py={5}
          px={mobile ? 0 : 5}
          sx={
            mobile
              ? {
                  flexGrow: 1,
                  border: "solid 1px #454E64",
                  borderRadius: "8px",
                  minHeight: "465px",
                }
              : {
                  flexGrow: 1,
                  minHeight: "465px",
                  border: "1px solid #454E64",
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                }
          }
          xs={12}
          md={8}
        >
          <Typography
            variant="h5"
            fontWeight={700}
            color="text.primary"
            m={2}
            className="calculator-field-text"
          >
            Find out what you can get, today !
          </Typography>
          <Grid container spacing={{ xs: 2, md: 3 }}>
            <Grid item xs={12} md={6}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-arr">
                  {focusedARR ? "ARR" : "Enter Your Annual Recurring Revenue"}
                </InputLabel>
                <OutlinedInput
                  type="text"
                  onFocus={() => setFocusedARR(true)}
                  onBlur={() => {
                    if (!arr) {
                      setFocusedARR(false);
                    }
                  }}
                  id="outlined-adornment-arr"
                  value={arr.toLocaleString("en-IN")}
                  onChange={handleArr}
                  // endAdornment={
                  //   <svg
                  //     width="24"
                  //     height="25"
                  //     viewBox="0 0 24 25"
                  //     fill="none"
                  //     xmlns="http://www.w3.org/2000/svg"
                  //   >
                  //     <path
                  //       d="M15.7061 13.7126C15.6739 13.4496 15.5808 13.1967 15.4337 12.9722C15.2484 12.6919 15.0053 12.4505 14.7192 12.2625C14.3002 11.9924 13.8326 11.7983 13.3399 11.6897L13.0178 11.6087V11.6087C12.8844 11.5769 12.8177 11.561 12.776 11.5144C12.7705 11.5082 12.7653 11.5017 12.7605 11.4948C12.7249 11.4435 12.7249 11.3749 12.7249 11.2378V9.89345C12.7249 9.69903 12.7249 9.60183 12.8171 9.54283C12.9093 9.48382 12.978 9.51549 13.1153 9.57881V9.57881C13.237 9.63494 13.3438 9.71662 13.4278 9.81772C13.5286 9.93405 13.6051 10.0663 13.6546 10.2073C13.7299 10.4219 13.7675 10.5292 13.8195 10.566C13.8715 10.6028 13.9555 10.6028 14.1236 10.6028H15.0257C15.2251 10.6028 15.3247 10.6028 15.3848 10.5294C15.4448 10.4559 15.4269 10.3681 15.3911 10.1923C15.347 9.97522 15.2739 9.76385 15.1731 9.56346C15.0321 9.28318 14.8328 9.03318 14.5874 8.82863C14.3377 8.62706 14.052 8.46995 13.744 8.36482C13.5283 8.28981 13.3068 8.23173 13.0816 8.19108C12.9039 8.15899 12.8151 8.14295 12.7685 8.08727C12.722 8.03159 12.722 7.94711 12.722 7.77815V7.60873C12.722 7.45995 12.722 7.38557 12.6844 7.33325C12.6718 7.31567 12.6563 7.30025 12.6388 7.28761C12.5865 7.25 12.5121 7.25 12.3633 7.25V7.25C12.2145 7.25 12.1401 7.25 12.0878 7.28761C12.0702 7.30025 12.0548 7.31567 12.0422 7.33325C12.0046 7.38557 12.0046 7.45995 12.0046 7.60873V7.7644C12.0046 7.93891 12.0046 8.02616 11.9562 8.0824C11.9078 8.13863 11.8152 8.15267 11.6299 8.18073C11.4 8.21554 11.1736 8.26962 10.9533 8.34247C10.6262 8.44823 10.3217 8.60911 10.0542 8.81746C9.77742 9.03493 9.55626 9.30979 9.40757 9.62111C9.25889 9.93244 9.1866 10.272 9.1962 10.614C9.18428 10.9471 9.25449 11.2783 9.40119 11.5808C9.53441 11.8301 9.72215 12.0492 9.95174 12.2234C10.1883 12.3998 10.452 12.5403 10.7336 12.6397C11.0265 12.7431 11.3193 12.8353 11.6121 12.9191C11.6941 12.9359 11.7674 12.9526 11.8376 12.9722V12.9722C11.8565 12.9772 11.8659 12.9797 11.8808 12.9864C11.9363 13.0114 11.9862 13.0763 11.9961 13.1364C11.9987 13.1525 11.9987 13.1666 11.9987 13.195V14.964C11.9987 15.191 11.9987 15.3044 11.9056 15.3633C11.8124 15.4222 11.7239 15.3802 11.547 15.2961C11.3684 15.2113 11.2058 15.0965 11.0675 14.956C10.9365 14.8119 10.8373 14.6441 10.7759 14.4627C10.7619 14.4211 10.7499 14.3791 10.7399 14.3366C10.6852 14.1031 10.6578 13.9864 10.6033 13.9431C10.5487 13.8998 10.4559 13.8998 10.2704 13.8998H9.43763C9.22944 13.8998 9.12535 13.8998 9.06539 13.9716C9.00543 14.0434 9.02294 14.1401 9.05797 14.3336C9.18461 15.0329 9.45812 15.5784 9.87852 15.9702C10.365 16.3851 10.9675 16.6503 11.6078 16.7365C11.8025 16.7627 11.8998 16.7758 11.9493 16.8323C11.9987 16.8888 11.9987 16.9788 11.9987 17.1587V17.3913C11.9987 17.54 11.9987 17.6144 12.0363 17.6667C12.049 17.6843 12.0644 17.6997 12.0819 17.7124C12.1343 17.75 12.2087 17.75 12.3574 17.75V17.75C12.5062 17.75 12.5806 17.75 12.6329 17.7124C12.6505 17.6997 12.6659 17.6843 12.6785 17.6667C12.7162 17.6144 12.7162 17.54 12.7162 17.3913V17.1591C12.7162 16.9818 12.7162 16.8931 12.7654 16.8366C12.8146 16.7801 12.9093 16.767 13.0988 16.7408C13.4837 16.6876 13.8586 16.5777 14.2097 16.4144C14.5588 16.2508 14.8735 16.0273 15.138 15.7551C15.5051 15.3709 15.7213 14.8772 15.75 14.358C15.7477 14.1423 15.733 13.9268 15.7061 13.7126ZM12.0038 10.9154C12.0042 11.1397 12.0043 11.2518 11.9157 11.3113C11.8271 11.3709 11.7358 11.3334 11.5533 11.2586C11.4181 11.2031 11.2895 11.1332 11.17 11.0499C11.0821 10.9756 11.0132 10.8831 10.9685 10.7794C10.9238 10.6758 10.9046 10.5638 10.9123 10.452C10.9082 10.3066 10.9392 10.1622 11.003 10.0301C11.0608 9.91347 11.146 9.81116 11.252 9.73111C11.3562 9.65019 11.4754 9.5886 11.6034 9.54949V9.54949C11.7631 9.50411 11.843 9.48142 11.9224 9.54132C12.0018 9.60122 12.0019 9.69881 12.0022 9.894L12.0038 10.9154ZM13.908 14.7869C13.908 14.7896 13.9073 14.7924 13.9059 14.7948C13.8308 14.9228 13.7324 15.037 13.6152 15.132C13.4872 15.225 13.3436 15.2968 13.1906 15.3443C13.1843 15.3464 13.1781 15.3484 13.1719 15.3504C12.991 15.408 12.9006 15.4368 12.8186 15.3769C12.7367 15.3169 12.7367 15.2102 12.7367 14.9966V13.7083C12.7367 13.4754 12.7367 13.359 12.8237 13.2994C12.9107 13.2398 13.01 13.2784 13.2088 13.3555C13.3918 13.4265 13.5673 13.5152 13.7323 13.6204C13.8335 13.7032 13.9127 13.8075 13.9636 13.925C14.0145 14.0425 14.0356 14.1698 14.0252 14.2966C14.0321 14.4643 13.9924 14.6308 13.91 14.7791C13.9087 14.7815 13.908 14.7842 13.908 14.7869V14.7869Z"
                  //       fill="white"
                  //       fill-opacity="0.5"
                  //     />
                  //     <path
                  //       d="M16.5 20.3089C14.9392 21.2358 13.1308 21.6379 11.3322 21.4581C9.53362 21.2783 7.83671 20.5256 6.48321 19.3074C5.12971 18.0891 4.18865 16.4674 3.79412 14.6733C3.39959 12.8792 3.3728 11.0874 4.08704 9.39858L3.63842 9.4667C3.50338 9.49805 3.36164 9.47355 3.24437 9.39858C3.1271 9.32361 3.04391 9.20433 3.01309 9.06696C2.98228 8.92959 3.00636 8.7854 3.08006 8.6661C3.15375 8.54681 3.27101 8.46217 3.40604 8.43083L5.19455 8.01382C5.32942 7.9819 5.47124 8.00578 5.5888 8.08022C5.70559 8.15612 5.78889 8.27513 5.82118 8.41223L6.2311 10.2343C6.2615 10.3717 6.23705 10.5157 6.16312 10.6347C6.08919 10.7538 5.97184 10.8381 5.83684 10.8691C5.79785 10.8743 5.75835 10.8743 5.71935 10.8691C5.60167 10.8686 5.48761 10.8277 5.39567 10.7529C5.30373 10.6782 5.2393 10.5741 5.21282 10.4574L5.19455 10.1202C4.64222 11.604 4.71965 13.1374 5.111 14.6733C5.50234 16.2092 6.30867 17.476 7.5 18.5C8.69133 19.524 9.94609 20.0638 11.5 20.2C13.0539 20.3362 14.4165 20.109 15.7624 19.3074L16.5 20.3089Z"
                  //       fill="white"
                  //       fill-opacity="0.5"
                  //     />
                  //     <path
                  //       d="M7.5 4.69112C9.14746 3.76424 11.0564 3.36206 12.9549 3.54188C14.8534 3.72171 16.6446 4.47436 18.0733 5.69261C19.502 6.91087 20.4953 8.53258 20.9118 10.3267C21.3282 12.1208 21.2539 13.8112 20.5 15.5L21.0761 15.5333C21.2187 15.5019 21.3683 15.5265 21.4921 15.6014C21.6158 15.6764 21.7037 15.7957 21.7362 15.933C21.7687 16.0704 21.7433 16.2146 21.6655 16.3339C21.5877 16.4532 21.4639 16.5378 21.3214 16.5692L19.4335 16.9862C19.2912 17.0181 19.1415 16.9942 19.0174 16.9198C18.8941 16.8439 18.8062 16.7249 18.7721 16.5878L18.3394 14.7657C18.3073 14.6283 18.3331 14.4843 18.4112 14.3653C18.4892 14.2462 18.6131 14.1619 18.7556 14.1309C18.7967 14.1257 18.8384 14.1257 18.8796 14.1309C19.0038 14.1314 19.1242 14.1723 19.2212 14.2471C19.3183 14.3218 19.3863 14.4259 19.4142 14.5426L19.4142 14.7657C19.9973 13.2819 19.9348 11.8626 19.5217 10.3267C19.1086 8.79085 18.2575 7.52402 17 6.5C15.7425 5.47598 14.3593 4.82731 12.719 4.69112C11.0788 4.55493 9.42073 5.19836 8 6L7.5 4.69112Z"
                  //       fill="white"
                  //       fill-opacity="0.5"
                  //     />
                  //   </svg>
                  // }
                  startAdornment={
                    arr && <InputAdornment position="start">₹</InputAdornment>
                  }
                  label={
                    focusedARR ? " ARR" : "Enter Your Annual Recurring Revenue"
                  }
                  autoComplete="off"
                  inputProps={{ maxLength: 21 }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                id="outlined-select-type"
                select
                label={type ? "Type" : "Select Type"}
                fullWidth
                value={type}
                onChange={handleType}
              >
                {Type.map((option) => (
                  <MenuItem
                    style={{
                      background: "#030914",
                      padding: "10px",
                      borderBottom: "solid .1px #233047",
                      margin: "0 10px",
                    }}
                    key={option}
                    value={option}
                  >
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                id="outlined-select-runway"
                select
                label={runway ? "Runway" : "Select Runway"}
                fullWidth
                value={runway}
                onChange={handleRunway}
              >
                {Runway.map((option) => (
                  <MenuItem
                    style={{
                      background: "#030914",
                      padding: "10px",
                      borderBottom: "solid .1px #233047",
                      margin: "0 10px",
                    }}
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                id="outlined-select-no-of-Customers"
                select
                label={
                  customers
                    ? "Number of Customers"
                    : "Select Number of Customers"
                }
                fullWidth
                value={customers}
                onChange={handleCustomers}
              >
                {NoOfCust.map((option) => (
                  <MenuItem
                    style={{
                      background: "#030914",
                      padding: "10px",
                      borderBottom: "solid .1px #233047",
                      margin: "0 10px",
                    }}
                    key={option}
                    value={option}
                  >
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-email">
                  {email ? "Email" : "Enter your Email"}
                </InputLabel>
                <OutlinedInput
                  type="text"
                  id="outlined-adornment-email"
                  value={email}
                  onChange={handleEmail}
                  onBlur={validateEmail}
                  label={email ? "Email" : "Enter your Email"}
                  autoComplete="off"
                />
                <FormHelperText error id="my-helper-text">
                  {emailHelper}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-phone-number">
                  {phoneNumber ? "Phone Number" : "Enter your Phone Number"}
                </InputLabel>
                <OutlinedInput
                  type="tel"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  id="outlined-adornment-phone"
                  value={phoneNumber.toLocaleString("en-IN")}
                  onChange={handlePhone}
                  inputProps={{ maxLength: 10 }}
                  onFocus={() => setInputBlur(true)}
                  onBlur={() => setInputBlur(false)}
                  label={
                    phoneNumber ? "Phone Number" : "Enter your Phone Number"
                  }
                  autoComplete="off"
                />
                {phoneNumber && !inputBlur && phoneNumber.length !== 10 && (
                  <FormHelperText error id="my-helper-text">
                    {"Please enter a valid phone number"}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button
                variant="contained"
                fullWidth={mobile}
                style={{ whiteSpace: "nowrap" }}
                onClick={calculate}
                className="calculate-button"
                disabled={
                  phoneNumber.length !== 10 ||
                  !!emailHelper ||
                  !arr ||
                  !phoneNumber ||
                  !email ||
                  !type ||
                  !runway ||
                  !customers ||
                  formSubmitted
                }
              >
                {(result.InterestRate ? "RE-" : "") + "CALCULATE FUNDING"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          className={
            (mobile || largeScreen) && !result.net_receivable
              ? "calculator-image dis-none"
              : "calculator-image"
          }
          item
          sx={
            mobile
              ? {
                  flexGrow: 1,
                  mt: 5,
                  border: "1px solid #454E64",
                  borderRadius: "8px",
                  minHeight: "465px",
                }
              : {
                  flexGrow: 1,
                  border: "1px solid #454E64",
                  borderLeft: "none",
                  borderTopRightRadius: "8px",
                  borderBottomRightRadius: "8px",
                  minHeight: "465px",
                }
          }
          xs={12}
          md={4}
        >
          <Stack
            sx={{ flexGrow: 1, minHeight: "465px" }}
            pt={result.net_receivable ? 10 : 0}
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            className={"calculater-img-wrapper"}
          >
            {result.net_receivable ? (
              <img
                src={CalculatorImg}
                alt=""
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "130px",
                  maxWidth: "164px",
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
              />
            ) : (
              <img
                src={CalcWithBgImg}
                alt=""
                style={{ width: "100%", height: "auto" }}
              />
            )}
            {result.net_receivable && (
              <>
                <Typography variant="h6" fontWeight={400} color="text.primary">
                  Raise upto
                </Typography>
                <Typography
                  marginTop={"0 !important"}
                  className="calculated-value"
                  variant={"h3"}
                  fontWeight={800}
                  color="#4C9EFF"
                >
                  ₹ {Math.round(result.net_receivable).toLocaleString("en-IN")}
                </Typography>
                <Divider
                  orientation="horizontal"
                  variant="dashed"
                  sx={{ width: "10%" }}
                  style={{ background: "#000 !important" }}
                />
                <Typography
                  textAlign={"center"}
                  variant="h6"
                  fontWeight={400}
                  color="text.primary"
                  display={"flex"}
                  alignItems="flex-end"
                >
                  EMI/Month{" "}
                  <Tooltip
                    className="bu-tooltip"
                    placement="top"
                    title="EMI will be calculated 12 months"
                    onClose={() => setShowTooltip(false)}
                    open={showTooltip}
                    arrow
                  >
                    <button
                      onClick={() => setShowTooltip(true)}
                      style={{
                        background: "transparent",
                        borderColor: "transparent",
                        padding: "0",
                      }}
                    >
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="8.50065"
                          cy="8.4987"
                          r="6.66667"
                          stroke="white"
                          stroke-width="1.4"
                        />
                        <path
                          d="M8.96652 5.63073C8.96652 5.88846 8.75759 6.0974 8.49986 6.0974C8.24212 6.0974 8.03319 5.88846 8.03319 5.63073C8.03319 5.373 8.24212 5.16406 8.49986 5.16406C8.75759 5.16406 8.96652 5.373 8.96652 5.63073Z"
                          fill="white"
                        />
                        <path
                          d="M8.5 7.83203V11.832"
                          stroke="white"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </Tooltip>
                </Typography>
                <Typography
                  className="net-amount"
                  variant={"h4"}
                  marginTop={"0 !important"}
                  fontWeight={800}
                  color="#4C9EFF"
                >
                  ₹
                  {Math.round(result.net_receivable / 12).toLocaleString(
                    "en-IN"
                  )}
                </Typography>
                <Divider orientation="horizontal" variant="dashed" flexItem />
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  marginTop={"0 !important"}
                  padding="12px"
                >
                  <Typography
                    variant="h6"
                    fontWeight={400}
                    color="text.primary"
                  >
                    Cost of Capital
                  </Typography>
                  <Typography
                    variant="h6"
                    fontWeight={400}
                    color="text.primary"
                  >
                    {result.InterestRate.toFixed(2)}%
                  </Typography>
                </Grid>
              </>
            )}
          </Stack>
        </Grid>
      </Grid>

      {result.BridgeUp && (
        <>
          <Grid
            className="dilution-wrapper"
            container
            spacing={0}
            p={5}
            sx={{ flexGrow: 1, minHeight: "465px" }}
            mb={mobile ? 10 : 10}
            marginBottom={"40px"}
          >
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={12}>
                <Typography variant="h3" fontWeight={700} color="text.primary">
                  Dilution
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              p={2}
              paddingTop={"70px"}
              className="dilution-left-wrapper"
            >
              <Grid
                item
                xs={12}
                md={6}
                xl={7}
                align={mobile ? "center" : "left"}
                className="dilution-left"
              >
                <Typography
                  // variant={"h4"}
                  fontWeight={400}
                  color="text.primary"
                  mt={mobile ? 0 : 10}
                  align={mobile ? "center" : "left"}
                  className="raise-value"
                  fontSize={"32px"}
                >
                  Raise
                  <Typography
                    fontWeight={700}
                    color="#4C9EFF"
                    variant={"h3"}
                    display="inline"
                    marginLeft={"5px"}
                    fontSize={"42px"}
                  >
                    ₹{Math.round(result.net_receivable).toLocaleString("en-IN")}
                    &nbsp;
                  </Typography>
                  and keep
                  <Typography
                    variant="h3"
                    fontWeight={800}
                    color="#4C9EFF"
                    align={mobile ? "center" : "left"}
                    className="percent-of-company"
                  >
                    <span>100%</span>
                    <Typography
                      // variant="h4"
                      fontWeight={400}
                      color="text.primary"
                      display="inline"
                      sx={{
                        fontSize: "32px",
                      }}
                      fontSize={"32px"}
                    >
                      {" "}
                      of the company
                    </Typography>
                  </Typography>
                </Typography>
                <Divider
                  hidden={!largeScreen}
                  orientation="horizontal"
                  variant="dashed"
                  sx={{ width: "50%", margin: 3 }}
                />
                <Typography
                  variant="h6"
                  fontWeight={400}
                  width={mobile ? "100%" : "430px"}
                  color="text.primary"
                  mt={4}
                  align={mobile ? "center" : "left"}
                >
                  Raising funds via BridgeUp is non-dilutive, meaning your
                  equity stays with your team!
                </Typography>
                <Button
                  onClick={signup}
                  variant="contained"
                  fullWidth={mobile}
                  sx={{ marginTop: "2rem", marginBottom: "2rem" }}
                >
                  RAISE FUNDING
                </Button>
              </Grid>
              <Grid className="bar-chart" item xs={12} md={6} xl={5}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  p={8}
                  sx={{
                    background:
                      "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165, 206, 255, 0.2) 0%, rgba(110, 191, 244, 0.0447917) 77.08%, rgba(70, 144, 213, 0) 100%)",
                    backgroundBlendMode: "overlay, normal",
                    filter: "drop-shadow(2px 16px 19px rgba(0, 0, 0, 0.09))",
                    backdropFilter: "blur(80px)",
                    borderRadius: "8px",
                    border: "1px solid #454E64",
                  }}
                >
                  <Stack
                    direction={mobile ? "column" : "row"}
                    alignItems="center"
                    divider={
                      !mobile ? (
                        <VSImg
                          style={{ marginTop: "15%", marginLeft: "7px" }}
                        />
                      ) : (
                        <VSImgHr />
                      )
                    }
                    spacing={{ xs: 2, md: 0, xl: 0 }}
                  >
                    <Stack direction="column" alignItems="center" spacing={0}>
                      <BridgeupDilution />
                      <Typography
                        variant="h6"
                        fontWeight={400}
                        color="text.primary"
                        display="inline"
                        mt={4.25}
                      >
                        BridgeUp Funding
                      </Typography>
                      <Typography
                        variant="h5"
                        fontWeight={700}
                        color="text.primary"
                        display="inline"
                        mt={1}
                      >
                        0% dilution
                      </Typography>
                    </Stack>
                    <Stack direction="column" alignItems="center" spacing={0}>
                      <PieChart
                        data={[
                          100 - result.dilution.toFixed(2),
                          result.dilution.toFixed(2),
                        ]}
                      />
                      <Typography
                        variant="h6"
                        fontWeight={400}
                        color="text.primary"
                        display="inline"
                        mt={3}
                      >
                        VC Funding
                      </Typography>
                      <Typography
                        variant="h5"
                        fontWeight={700}
                        color="text.primary"
                        display="inline"
                        mt={1}
                      >
                        {result.dilution.toFixed(2)}% dilution
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={0}
            p={5}
            paddingBottom={15}
            sx={{ flexGrow: 1, minHeight: "465px" }}
            className="coc-wrapper"
          >
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  fontWeight={700}
                  color="text.primary"
                  align="center"
                >
                  Cost of Capital
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              p={2}
              paddingTop={"70px"}
              className="dilution-left-wrapper"
            >
              <Grid
                item
                xs={12}
                md={6}
                xl={7}
                align={mobile ? "center" : "left"}
                className="coc-left"
              >
                <Typography
                  fontWeight={400}
                  width={mobile ? "100%" : "38%"}
                  color="text.primary"
                  mt={mobile ? 0 : 10}
                  align={"center"}
                  className="save-up-to-message"
                >
                  Save upto
                  <Typography
                    variant="h3"
                    fontWeight={800}
                    color="primary"
                    display="inline"
                  >
                    {" "}
                    4X{" "}
                  </Typography>{" "}
                  on BridgeUp
                </Typography>
                {/* <Typography
                  fontSize={"32px"}
                  fontWeight={400}
                  color="text.primary"
                >
                  on BridgeUp
                </Typography> */}
                <Divider
                  hidden={!largeScreen}
                  orientation="horizontal"
                  variant="dashed"
                  sx={{ width: "50%", margin: 3 }}
                />
                <Typography
                  variant="h6"
                  fontWeight={400}
                  width={mobile ? "100%" : "344px"}
                  color="text.primary"
                  mt={4}
                  align={mobile ? "center" : "left"}
                >
                  BridgeUp gives you more savings as compared to Venture Debt &
                  Equity
                </Typography>
              </Grid>
              <Grid className="bar-chart" item xs={12} md={6} xl={5}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  py={4}
                  sx={{
                    background:
                      "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165, 206, 255, 0.2) 0%, rgba(110, 191, 244, 0.0447917) 77.08%, rgba(70, 144, 213, 0) 100%)",
                    backgroundBlendMode: "overlay, normal",
                    filter: "drop-shadow(2px 16px 19px rgba(0, 0, 0, 0.09))",
                    backdropFilter: "blur(80px)",
                    borderRadius: "8px",
                    border: "1px solid #454E64",
                  }}
                >
                  <Stack direction="column" alignItems="center" spacing={1}>
                    <BarChart
                      values={[result.BridgeUp, result.venture, result.equity]}
                      labels={
                        mobile
                          ? [["BridgeUp"], ["Venture", "Debt"], ["Equity"]]
                          : ["BridgeUp", "Venture Debt", "Equity"]
                      }
                    />
                    <Typography
                      variant="h5"
                      fontWeight={500}
                      color="text.primary"
                    >
                      Cost of Capital
                    </Typography>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}

export default Calculator;
